import AppFlowActions from '../../constants';

export default function getAllRequest() {
  return ({ type: AppFlowActions.GET_ALL_DATA_REQUEST });
}
